import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { requestV3 } from 'Features/Auth/axios-client'
import { SiteStockFlowData } from './SiteStockFlow.types'

const fetchSiteStockFlow = async (projectId: string, scenarioId: string) => {
  const { data } = await requestV3({
    url: `/site-stock-flow?projectId=${projectId}&scenarioId=${scenarioId}`,
  })
  return data
}

export const useSiteStockFlow = ({
  projectId,
  scenarioId,
}: {
  projectId: string
  scenarioId: string
}): UseQueryResult<SiteStockFlowData[]> => {
  return useQuery({
    queryKey: ['site-stock-flow', projectId, scenarioId],
    queryFn: () => fetchSiteStockFlow(projectId, scenarioId),
    select: (data) => data.data,
    gcTime: Infinity,
  })
}
